module.exports = -> "
  <div class='modalize-backdrop js-modalize-backdrop'>
    <div class='modalize-dialog js-modalize-dialog'>
      <a class='modalize-close js-modalize-close'>
        <i class='icon-close'></i>
      </a>

      <section class='modalize-body js-modalize-body'>
        <!-- Rendered separately -->
      </section>
    </div>
  </div>
"
